module.exports = __webpack_public_path__ + "static/media/sup_tropical_768.4fcbb838.webp";